import Tabs from "@/shared/data-display/tabs";
import { FC, ReactNode, useState } from "react";
import { useLocalizedFields } from "@/shared/form/localized-value/model/localized-field";
import { useTabItems } from "../model/useTabItems";

export function LocaleTabs({
  name,
  propertyTree,
  errorTooltip,
  CopyToOthersLanguages,
}: {
  name: string | string[];
  propertyTree: ReactNode;
  errorTooltip?: ReactNode;
  CopyToOthersLanguages: FC<{ activeLanguage?: string }>;
}) {
  const tabs = useTabItems(name, propertyTree);
  const { languages, localeToControlName } = useLocalizedFields();

  const [activeKey, setActiveKey] = useState<string>(
    localeToControlName(languages[0]),
  );

  return (
    <Tabs
      activeKey={activeKey}
      onChange={setActiveKey}
      destroyInactiveTabPane
      tabBarExtraContent={{
        right: (
          <div className={"mr-3"}>
            <CopyToOthersLanguages activeLanguage={activeKey} />
          </div>
        ),
        left: <div className="ml-3">{errorTooltip}</div>,
      }}
      tabBarStyle={{ marginBottom: 5 }}
      items={tabs}
      centered
    />
  );
}
